export default "__VITE_ASSET__c69fbfcd__"